"use strict";

var _taggedTemplateLiteral = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const styled_components_1 = __importDefault(require("styled-components"));

const Button = styled_components_1.default.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  user-select: none;\n  outline: none;\n  margin: 0;\n  padding: 0.5rem 1rem;\n  font-size: 1rem;\n  font-family: inherit;\n  background: transparent;\n  border: none;\n  color: inherit;\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  &:disabled {\n    pointer-events: none;\n  }\n"])));
exports.default = Button;